(function () {
  if (window.__paperStoreBagGlobalReady) return;
  window.__paperStoreBagGlobalReady = true;

  var AUTO_BAG_TYPE = 'Bolsa Papel Store automática';
  var OPTIONAL_BAG_TYPE = 'Bolsa o empaque';

  var syncTimer = null;
  var syncInProgress = false;
  var rerunRequested = false;
  var drawerRefreshInProgress = false;
  var mainRefreshInProgress = false;
  var originalFetch = window.fetch.bind(window);

  function getRootUrl() {
    return window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root
      : '/';
  }

  function getConfig() {
    return document.querySelector('[data-paper-store-bag-global-config]');
  }

  function getItemType(item) {
    if (!item || !item.properties) return '';
    return item.properties['_Tipo'] || '';
  }

  function isAutomaticBag(item, variantId) {
    return (
      getItemType(item) === AUTO_BAG_TYPE ||
      String(item.variant_id) === String(variantId)
    );
  }

  function isOptionalBag(item) {
    return getItemType(item) === OPTIONAL_BAG_TYPE;
  }

  function isGiftCard(item) {
    if (!item) return false;

    // Gift Card nativa de Shopify
    if (item.gift_card === true) {
      return true;
    }

    // Respaldo por Product type
    var productType = String(item.product_type || '')
      .trim()
      .toLowerCase();

    return (
      productType === 'gift card' ||
      productType === 'gift cards'
    );
  }
  
  function requestJSON(url, options) {
    return window.fetch(url, options).then(function (response) {
      if (response.ok) return response.json();

      return response
        .json()
        .catch(function () {
          return {
            status: response.status,
            message: 'No se pudo actualizar el carrito.'
          };
        })
        .then(function (error) {
          throw error;
        });
    });
  }

  function fetchCart() {
    return requestJSON(getRootUrl() + 'cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      cache: 'no-store'
    });
  }

  function addAutomaticBags(variantId, quantity) {
    return requestJSON(getRootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: Number(quantity),
            properties: {
              '_Tipo': AUTO_BAG_TYPE
            }
          }
        ]
      })
    });
  }

  function changeLineQuantity(itemKey, quantity) {
    return requestJSON(getRootUrl() + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: itemKey,
        quantity: Number(quantity)
      })
    });
  }

  function normalizeAutomaticBagLines(items, requiredQuantity) {
    var actions = [];
    var quantityAssigned = false;

    items.forEach(function (item) {
      if (!quantityAssigned) {
        if (Number(item.quantity) !== Number(requiredQuantity)) {
          actions.push(function () {
            return changeLineQuantity(item.key, requiredQuantity);
          });
        }

        quantityAssigned = true;
        return;
      }

      actions.push(function () {
        return changeLineQuantity(item.key, 0);
      });
    });

    return actions.reduce(function (promise, action) {
      return promise.then(action);
    }, Promise.resolve());
  }

  function replaceAutomaticBagLines(
    items,
    variantId,
    requiredQuantity
  ) {
    var removeActions = items.map(function (item) {
      return function () {
        return changeLineQuantity(item.key, 0);
      };
    });

    return removeActions
      .reduce(function (promise, action) {
        return promise.then(action);
      }, Promise.resolve())
      .then(function () {
        if (requiredQuantity <= 0) {
          return null;
        }

        return addAutomaticBags(
          variantId,
          requiredQuantity
        );
      });
  }

  function getVisibleItemCount(cart, variantId) {
    var automaticBagQuantity = 0;

    (cart.items || []).forEach(function (item) {
      if (isAutomaticBag(item, variantId)) {
        automaticBagQuantity += Number(item.quantity || 0);
      }
    });

    return Math.max(
      0,
      Number(cart.item_count || 0) - automaticBagQuantity
    );
  }

  function updateHeaderCounter(cart, variantId) {
    var quantity = getVisibleItemCount(cart, variantId);

    document
      .querySelectorAll('cart-count.cart-count--absolute')
      .forEach(function (counter) {
        counter.hidden = quantity <= 0;
        counter.classList.toggle(
          'cart-count--small-medium',
          quantity > 99
        );

        if (quantity > 99) {
          counter.innerHTML =
            '<span class="text-sm-extra">99+</span>';
        } else {
          counter.textContent = quantity;
        }

        counter.setAttribute(
          'aria-label',
          'Carrito: ' + quantity + ' artículos'
        );
      });
  }

  function getDrawerSectionData() {
    var drawer = document.getElementById('CartDrawer');

    if (!drawer) return null;

    var sectionId = drawer.getAttribute('data-section-id');

    if (!sectionId) return null;

    var content = document.getElementById(
      'CartDrawer-' + sectionId
    );

    if (!content) return null;

    return {
      drawer: drawer,
      sectionId: sectionId,
      content: content
    };
  }

  function refreshCartDrawer() {
    var data = getDrawerSectionData();

    if (!data || drawerRefreshInProgress) {
      return Promise.resolve();
    }

    drawerRefreshInProgress = true;

    var scrollable = data.content.querySelector(
      '.drawer__body.v-scrollable:not(.hidden)'
    );
    var previousScrollTop = scrollable
      ? scrollable.scrollTop
      : 0;

    data.drawer.classList.add(
      'is-paper-store-bag-refreshing'
    );

    var requestUrl = new URL(
      window.location.pathname,
      window.location.origin
    );

    requestUrl.searchParams.set(
      'section_id',
      data.sectionId
    );
    requestUrl.searchParams.set(
      '_paper_store_bag_refresh',
      Date.now()
    );

    return window.fetch(requestUrl.toString(), {
      method: 'GET',
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'No se pudo renderizar el cart drawer. Estado: ' +
              response.status
          );
        }

        return response.text();
      })
      .then(function (sectionHtml) {
        if (!sectionHtml || !sectionHtml.trim()) {
          throw new Error(
            'Shopify devolvió vacío el cart drawer.'
          );
        }

        var parsedDocument = new DOMParser().parseFromString(
          sectionHtml,
          'text/html'
        );

        var incomingContent =
          parsedDocument.getElementById(
            'CartDrawer-' + data.sectionId
          );

        if (!incomingContent) {
          throw new Error(
            'Shopify no devolvió el contenido del cart drawer.'
          );
        }

        function updateDrawerRegion(id) {
  var currentElement =
    document.getElementById(id);

  var incomingElement =
    parsedDocument.getElementById(id);

  if (!currentElement || !incomingElement) {
    return;
  }

  /*
   * Actualizamos únicamente el contenido dinámico
   * del carrito.
   *
   * IMPORTANTE:
   * No reemplazamos el header del CartDrawer,
   * porque ahí vive el botón de cerrar y sus
   * listeners originales.
   */
  currentElement.innerHTML =
    incomingElement.innerHTML;

  /*
   * Copiamos también las clases para mantener
   * correctamente los estados hidden cuando
   * el carrito queda vacío o vuelve a tener items.
   */
  currentElement.className =
    incomingElement.className;
}

updateDrawerRegion(
  'CartDrawerEmpty-' + data.sectionId
);

updateDrawerRegion(
  'CartDrawerBody-' + data.sectionId
);

updateDrawerRegion(
  'CartDrawerFooter-' + data.sectionId
);

/*
 * El contador del título está dentro del header.
 * Como NO reemplazamos el header, actualizamos
 * solamente el cart-count manualmente.
 */
var currentDrawerCounter =
  data.content.querySelector(
    'cart-count.cart-count--blank'
  );

var incomingDrawerCounter =
  incomingContent.querySelector(
    'cart-count.cart-count--blank'
  );

if (
  currentDrawerCounter &&
  incomingDrawerCounter
) {
  currentDrawerCounter.innerHTML =
    incomingDrawerCounter.innerHTML;

  currentDrawerCounter.hidden =
    incomingDrawerCounter.hidden;

  var counterLabel =
    incomingDrawerCounter.getAttribute(
      'aria-label'
    );

  if (counterLabel !== null) {
    currentDrawerCounter.setAttribute(
      'aria-label',
      counterLabel
    );
  }
}

        requestAnimationFrame(function () {
          var refreshedScrollable =
            data.content.querySelector(
              '.drawer__body.v-scrollable:not(.hidden)'
            );

          if (refreshedScrollable) {
            refreshedScrollable.scrollTop =
              previousScrollTop;
          }
        });
      })
      .catch(function (error) {
        console.error(
          '[Bolsa Papel Store: drawer]',
          error
        );
      })
      .finally(function () {
        drawerRefreshInProgress = false;
        data.drawer.classList.remove(
          'is-paper-store-bag-refreshing'
        );
      });
  }

  function getMainCartSectionId() {
    var mainCart = document.querySelector(
      'main-cart[id^="MainCart-"]'
    );

    if (!mainCart) return '';

    return mainCart.id.replace('MainCart-', '');
  }

  function refreshMainCart() {
    var sectionId = getMainCartSectionId();

    if (!sectionId || mainRefreshInProgress) {
      return Promise.resolve();
    }

    if (
      typeof window.refreshMainCartAjax === 'function'
    ) {
      mainRefreshInProgress = true;

      return window
        .refreshMainCartAjax(sectionId)
        .catch(function (error) {
          console.error(
            '[Bolsa Papel Store: main cart]',
            error
          );
        })
        .finally(function () {
          mainRefreshInProgress = false;
        });
    }

    return Promise.resolve();
  }

  function refreshCartInterfaces(cart, variantId) {
    updateHeaderCounter(cart, variantId);

    return Promise.all([
      refreshCartDrawer(),
      refreshMainCart()
    ]).then(function () {
      document.dispatchEvent(
        new CustomEvent('cart:rendered', {
          detail: {
            cart: cart,
            source: 'paper-store-bag-global'
          }
        })
      );

      return cart;
    });
  }

  function synchronizeAutomaticBag() {
    var config = getConfig();

    if (!config) {
      return Promise.resolve();
    }

    if (syncInProgress) {
      rerunRequested = true;
      return Promise.resolve();
    }

    var enabled =
      config.getAttribute('data-enabled') === 'true';
    var variantId =
      config.getAttribute('data-variant-id');
    var itemsPerBag = parseInt(
      config.getAttribute('data-items-per-bag') || '4',
      10
    );

    if (!variantId) {
      return Promise.resolve();
    }

    if (!itemsPerBag || itemsPerBag < 1) {
      itemsPerBag = 4;
    }

    syncInProgress = true;
    rerunRequested = false;

    return fetchCart()
      .then(function (cart) {
        var regularQuantity = 0;
        var automaticBagQuantity = 0;
        var automaticBagItems = [];
        var needsPropertyMigration = false;

        (cart.items || []).forEach(function (item) {
          if (isAutomaticBag(item, variantId)) {
            automaticBagQuantity += Number(
              item.quantity || 0
            );
            automaticBagItems.push(item);

            if (getItemType(item) !== AUTO_BAG_TYPE) {
              needsPropertyMigration = true;
            }

            return;
          }

          if (isOptionalBag(item) || isGiftCard(item)) {
            return;
          }

          regularQuantity += Number(
            item.quantity || 0
          );
        });

        var requiredQuantity = enabled
          ? Math.ceil(regularQuantity / itemsPerBag)
          : 0;

        if (regularQuantity <= 0) {
          requiredQuantity = 0;
        }

        if (needsPropertyMigration) {
          return replaceAutomaticBagLines(
            automaticBagItems,
            variantId,
            requiredQuantity
          )
            .then(fetchCart)
            .then(function (updatedCart) {
              return {
                changed: true,
                cart: updatedCart
              };
            });
        }

        if (
          automaticBagQuantity === requiredQuantity &&
          automaticBagItems.length <= 1
        ) {
          updateHeaderCounter(cart, variantId);

          return {
            changed: false,
            cart: cart
          };
        }

        if (
          automaticBagQuantity < requiredQuantity
        ) {
          return addAutomaticBags(
            variantId,
            requiredQuantity - automaticBagQuantity
          )
            .then(fetchCart)
            .then(function (updatedCart) {
              return {
                changed: true,
                cart: updatedCart
              };
            });
        }

        return normalizeAutomaticBagLines(
          automaticBagItems,
          requiredQuantity
        )
          .then(fetchCart)
          .then(function (updatedCart) {
            return {
              changed: true,
              cart: updatedCart
            };
          });
      })
      .then(function (result) {
        if (!result) return;

        if (!result.changed) {
          return result.cart;
        }

        return refreshCartInterfaces(
          result.cart,
          variantId
        );
      })
      .catch(function (error) {
        console.error(
          '[Bolsa Papel Store global]',
          error
        );
      })
      .finally(function () {
        syncInProgress = false;

        if (rerunRequested) {
          rerunRequested = false;
          scheduleSync(80);
        }
      });
  }

  function scheduleSync(delay) {
    clearTimeout(syncTimer);

    syncTimer = setTimeout(function () {
      synchronizeAutomaticBag();
    }, typeof delay === 'number' ? delay : 300);
  }

  function isCartMutationRequest(input, options) {
    var url = '';

    if (typeof input === 'string') {
      url = input;
    } else if (input && input.url) {
      url = input.url;
    }

    if (!url) return false;

    var method =
      (options && options.method) ||
      (input && input.method) ||
      'GET';

    method = String(method).toUpperCase();

    if (method === 'GET' || method === 'HEAD') {
      return false;
    }

    try {
      var parsedUrl = new URL(url, window.location.origin);

      return /\/cart\/(add|change|update|clear)(\.js)?$/i.test(
        parsedUrl.pathname
      );
    } catch (error) {
      return false;
    }
  }

  window.fetch = function (input, options) {
    var shouldSchedule =
      isCartMutationRequest(input, options);

    return originalFetch(input, options).then(function (
      response
    ) {
      if (shouldSchedule && response.ok) {
        scheduleSync(260);
      }

      return response;
    });
  };

  window.syncPaperStoreBagGlobal =
    synchronizeAutomaticBag;

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      scheduleSync(120);
    }
  );

  document.addEventListener(
    'shopify:section:load',
    function () {
      scheduleSync(120);
    }
  );

  [
    'cart:updated',
    'cart:change',
    'cart:refresh',
    'cart:rendered',
    'product:added'
  ].forEach(function (eventName) {
    document.addEventListener(
      eventName,
      function (event) {
        if (
          eventName === 'cart:rendered' &&
          event.detail &&
          event.detail.source ===
            'paper-store-bag-global'
        ) {
          return;
        }

        scheduleSync(220);
      }
    );
  });

  var observer = new MutationObserver(function (
    mutations
  ) {
    var shouldSync = mutations.some(function (
      mutation
    ) {
      if (mutation.type !== 'childList') {
        return false;
      }

      return Array.from(
        mutation.addedNodes || []
      ).some(function (node) {
        if (
          !node ||
          node.nodeType !== Node.ELEMENT_NODE
        ) {
          return false;
        }

        return Boolean(
          (node.matches &&
            node.matches(
              'cart-drawer, main-cart, cart-items, .cart-item'
            )) ||
            (node.querySelector &&
              node.querySelector(
                'cart-drawer, main-cart, cart-items, .cart-item'
              ))
        );
      });
    });

    if (shouldSync) {
      scheduleSync(260);
    }
  });

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  );
})();